import { render, staticRenderFns } from "./ContentChainsList.vue?vue&type=template&id=6ce47886&scoped=true&"
import script from "./ContentChainsList.vue?vue&type=script&lang=js&"
export * from "./ContentChainsList.vue?vue&type=script&lang=js&"
import style0 from "./ContentChainsList.vue?vue&type=style&index=0&id=6ce47886&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce47886",
  null
  
)

export default component.exports